import React, { useState, useContext, useEffect, useRef } from "react";
import RegistroCompleto from "./RegistroCompleto";
import "../../assets/css/login.css";
import { Auth } from "../../utils/AuthContext";

import logo_banner_ergistro from "../../assets/images/2025/casaduana_registro.jpg";
import img_registrar from "../../assets/images/2025/Logos_Botones_Iconos/casaduana_Registrate.svg";

import {
  Form,
  Select,
  Row,
  Col,
  Checkbox,
  notification,
  Spin,
} from "antd";
import Firebase from "../../utils/firebaseConfig";
import {
  mail_registro_confirmacion,
  existe_empresa,
} from "../../utils/ConexionServidor";

import { withRouter } from "react-router";
import ReCAPTCHA from "react-google-recaptcha";



const openNotificationWithIcon = (type, titulo, texto) => {
  notification[type]({
    message: titulo,
    description: texto,
    duration: 10,
  });
};

const nom_evento = "2026";

const { Option } = Select;

let correo_registrado = "",
  password_registrado = "",
  perfil_registrado = "";

const app = new Firebase();

const success = () => {
  openNotificationWithIcon("success", "Bienvenido", "");
};

const FromRegister = ({ setsignup, history, tipo_registro, idioma }) => {
  const [otro_medio, setOtroMedio] = useState(false);
  const [confirmacion, setConfirmacion] = useState(false);
  const [cargando_regsitro, setCargandoRegistro] = useState(false);
  const { usuario, datos } = useContext(Auth);
  const [mostrar_login, setMostrarLogin] = useState(false);
  const [reutilizar_datos, setReutilizarDatos] = useState(false);
  const [tipo_perfl, setTipoPerfil] = useState("");
  const [nombre_completo, setNombreCompleto] = useState("");
  const [empresa_repetida, setEmpresaRepetida] = useState(false);
  const [perfil_elegido, setPerfilElegido] = useState(false);

  const [form] = Form.useForm();

  const ref_form = React.createRef();
  const ref_organizacion = React.createRef();
  const ref_recaptcha = React.createRef();

  const elegirMedio = (value) => {
    if (value === "Otro") {
      setOtroMedio(true);
    } else {
      setOtroMedio(false);
    }
  };

  useEffect(() => {
    if (usuario) {
      app.app
        .auth()
        .signOut()
        .then(function () {})
        .catch(function (error) {
          // An error happened.
        });
    }
  }, []);

  useEffect(() => {
    setEmpresaRepetida(false);
  }, [tipo_perfl]);

  useEffect(() => {
    if (reutilizar_datos) {
      if (datos) {

        datos.nombre_curso = nom_evento;
        datos.apellidos = datos.ap_paterno + " " + datos.ap_materno;

        mail_registro_confirmacion(datos).then(({ data, status }) => {
          switch (status) {
            case 0:
              //delete values.aceptar_terminos;
              app.escribir(
                nom_evento + "/usuarios",
                undefined,
                datos,
                () => {}
              );

              openNotificationWithIcon("success", "", data);
              setConfirmacion(true);
              break;
            default:
              openNotificationWithIcon("warning", "", data);
              setConfirmacion(false);
              break;
          }
          //setCargandoRegistro(false);
          setMostrarLogin(false);
        });
        setReutilizarDatos(false);
      } else {
      }
    }
  }, [datos, reutilizar_datos]);

  const onFinish = async (values) => {
    if (empresa_repetida) {
      openNotificationWithIcon(
        "warning",
        "YA EXISTE UN REGISTRO PARA ESTA EMPRESA",
        "Le recordamos que el evento presencial esta restringido a un registro por empresa, por lo que le sugerimos hacer el resto de sus inscipciones en el apartado “REGISTRO A EVENTO VIRTUAL”"
      );
      return;
    }

    setCargandoRegistro(true);

    let recaptcha = "sin-recaptcha"; //ref_recaptcha.current.getValue();

    values.correo = values.correo.toLowerCase();
    values.idioma = idioma;

    const { correo } = values;

    setNombreCompleto(values.nombre + " " + values.ap_paterno);

    let contra = values.password;

    correo_registrado = correo;

    values.nombre_curso = nom_evento;

    values.apellidos = values.ap_paterno;

    values["g-recaptcha-response"] = recaptcha;

    const acentos = {
      á: "a",
      é: "e",
      í: "i",
      ó: "o",
      ú: "u",
      Á: "A",
      É: "E",
      Í: "I",
      Ó: "O",
      Ú: "U",
    };
    values.pass = values.ap_paterno
      .split("")
      .map((letra) => acentos[letra] || letra)
      .join("")
      .toString()
      .toLowerCase();

    password_registrado = values.pass;
    perfil_registrado = values.perfil;

    values.tipo_entrada = "presencial";

    mail_registro_confirmacion(values).then(({ data, status }) => {
      switch (status) {
        case 0:
          delete values.medios;
          delete values.pass;
          delete values.aceptar_terminos;
          //delete values.aceptar_networking;
          delete values.comite_infraestructura;
          delete values.comite_asg;
          delete values.membresia;

          delete values.otro_procedencia;

          openNotificationWithIcon("success", "", data);
          setConfirmacion(true);
          break;
        default:
          openNotificationWithIcon("warning", "", data);
          setConfirmacion(false);
          break;
      }
      setCargandoRegistro(false);
    });
  };

  const revisarEmpresa = (empresa) => {
    if (tipo_registro === "presencial") {
      existe_empresa({ empresa: empresa }).then(({ data }) => {
        if (data === 1) {
          openNotificationWithIcon(
            "warning",
            "YA EXISTE UN REGISTRO PARA ESTA EMPRESA",
            "Le recordamos que el evento presencial esta restringido a un registro por empresa, por lo que le sugerimos hacer el resto de sus inscipciones en el apartado “REGISTRO A EVENTO VIRTUAL”"
          );
          setEmpresaRepetida(true);
        } else {
          setEmpresaRepetida(false);
        }
      });
    }
  };

  const revisarPErfil = (perfil) => {
    if (perfil !== "") {
      setPerfilElegido(true);
    }
  };

  return (
    <>
      <Spin tip="Cargando..." spinning={cargando_regsitro}>
        <Row
          justify="center"
          align="middle"
          style={{
            minHeight: "100vh",
            padding: "40px 0",
          }}
        >
          {/* Imagen centrada */}
          <Col xs={18} md={9} style={{ textAlign: "center" }}>
            <img
              src={logo_banner_ergistro}
              className="img-banner-registro"
              style={{
                maxWidth: "620px",
                margin: "0 auto",
                display: "block",
              }}
            />
          </Col>
        {confirmacion ? (
            <Col xs={{ span: 20, offset: 0 }} md={{ span: 10, offset: 1 }}>
              <RegistroCompleto
                correo={correo_registrado}
                password={password_registrado}
                tipo_registro={tipo_registro}
                nombre={nombre_completo}
                idioma={idioma}
              />
            </Col>
          ) : (
          <Col xs={22} md={{ span: 8, offset: 1 }}>
            <div className="registro-card">
              <h2 className="titulo-registro">¡Regístrate gratis!</h2>

              <Form
                layout="vertical"
                form={form}
                ref={ref_form}
                initialValues={{ organizacion: "" }}
                onFinish={onFinish}
              >
                <Row gutter={[16, 0]}>
                  <Col span={24}>
                    <Form.Item
                      name="nombre"
                      rules={[{ required: true, message: "Ingresa tu nombre" }]}
                    >
                      <input className="input-registro" placeholder="Nombre" />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="ap_paterno"
                      rules={[
                        { required: true, message: "Ingresa tu apellido" },
                      ]}
                    >
                      <input
                        className="input-registro"
                        placeholder="Apellidos"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="empresa"
                      rules={[
                        { required: true, message: "Ingresa una empresa" },
                      ]}
                    >
                      <input className="input-registro" placeholder="Empresa" />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="correo"
                      rules={[
                        { required: true, message: "Ingresa un correo válido" },
                      ]}
                    >
                      <input
                        className="input-registro"
                        placeholder="Correo electrónico"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="telefono"
                      rules={[
                        { required: true, message: "Ingresa tu teléfono" },
                      ]}
                    >
                      <input
                        type="number"
                        className="input-registro"
                        placeholder="Teléfono"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="perfil"
                      rules={[{ required: true, message: "Elige una opción" }]}
                    >
                      <Select
                        className="input-select"
                        placeholder="¿Eres cliente CASADUANA®?"
                      >
                        <Option value="1">Soy Cliente</Option>
                        <Option value="0">Aún no soy Cliente</Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="medio"
                      rules={[
                        { required: true, message: "Selecciona una opción" },
                      ]}
                    >
                      <Select
                        className="input-select"
                        placeholder="¿Por cuál medio te enteraste?"
                        onChange={elegirMedio}
                      >
                        <Option value="Facebook">Facebook</Option>
                        <Option value="Twitter">Twitter</Option>
                        <Option value="Instagram">Instagram</Option>
                        <Option value="Correo electrónico">
                          Correo electrónico
                        </Option>
                        <Option value="Whatsapp">Whatsapp</Option>
                        <Option value="Otro">Otro</Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item name="membresia" valuePropName="checked">
                      <Checkbox className="checkbox-registro">
                        Forma parte de nuestra lista de difusión
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  {/* Botón */}
                  <Col span={24} style={{ textAlign: "center" }}>
                    <span onClick={() => ref_form.current.submit()}>
                      <img src={img_registrar} className="btn-registrar-img" />
                    </span>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
          )}
        </Row>
                    
      </Spin>
    </>
  );
};

export default withRouter(FromRegister);
